export default {"src":"/_next/static/media/intelligence-solutions-chart.c9b7a62d.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};